import React from 'react';
import { IconType } from 'react-icons';

interface EmptyStateProps {
  icon?: IconType;
  title?: string;
  description?: string;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title = 'No data found',
  description = 'There are no items to display at the moment.',
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center py-12 text-center ${className}`}
    >
      {Icon && (
        <div className="mb-4 text-gray-400">
          <Icon className="w-12 h-12" />
        </div>
      )}
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-500 max-w-sm">{description}</p>
    </div>
  );
};

export default EmptyState;
